import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import ConfigPanel from './components/ConfigPanel';
import RecordingDisclaimer from './components/RecordingDisclaimer';
import { OperatorConfigProvider } from './hooks/useOperatorConfig';
import { ConnectionStatusProvider } from './hooks/useConnectionStatus';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginPage from './pages/LoginPage';
import useBreakpoint from './hooks/useBreakpoint';

export default function App() {
  return (
    <OperatorConfigProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </OperatorConfigProvider>
  );
}

function AppShell() {
  const [configOpen, setConfigOpen] = useState(false);
  const { isAuthenticated, isReady } = useAuth();
  const { isMobile } = useBreakpoint();

  if (!isReady) {
    return (
      <div className="app-loading">
        <div className="app-loading__inner">
          <div className="app-loading__ring" />
          <span>Verifying session</span>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      {isAuthenticated ? (
        <ConnectionStatusProvider>
          <Header onOpenSettings={() => setConfigOpen(true)} />
          <main className="content">
            <Outlet />
          </main>
        </ConnectionStatusProvider>
      ) : (
        <LoginPage />
      )}
      <ConfigPanel open={configOpen} onClose={() => setConfigOpen(false)} />
      <RecordingDisclaimer />
      <Toaster
        position={isMobile ? 'bottom-center' : 'bottom-right'}
        toastOptions={{
          style: {
            background: 'var(--surface-raised)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border-subtle)',
            boxShadow: 'var(--shadow-raised)',
            fontWeight: 500,
            fontSize: '13px',
            borderRadius: '8px',
          },
          success: {
            iconTheme: { primary: 'var(--status-ok)', secondary: 'var(--surface-raised)' },
          },
          error: {
            iconTheme: { primary: 'var(--critical)', secondary: 'var(--surface-raised)' },
          },
        }}
      />
    </div>
  );
}
